import * as React from 'react';
import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import SettingsIcon from '@mui/icons-material/Settings';
import { FeatureFlagApi } from 'lib/api/feature-flag';
import { FeatureFlagDTO } from 'lib/api/feature-flag.protocols';
import { SETTINGS_MODULES } from 'modules/settings/config/modules.config';
import { ModuleCard } from 'modules/settings/components/ModuleCard';

export const SettingsListPage = () => {
  const navigate = useNavigate();
  const [flags, setFlags] = useState<FeatureFlagDTO[] | null>(null);
  const [error, setError] = useState(false);

  const fetchFlags = useCallback(() => {
    setError(false);
    setFlags(null);
    FeatureFlagApi.getFeatureFlags()
      .then(setFlags)
      .catch(() => setError(true));
  }, []);

  useEffect(() => {
    fetchFlags();
  }, [fetchFlags]);

  return (
    <Container sx={{ my: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 3 }}>
        <SettingsIcon fontSize="large" color="primary" />
        <Box>
          <Typography variant="h5" fontWeight={700}>
            Configurações
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Selecione um módulo para gerenciar suas funcionalidades e ativar ou
            desativar recursos no sistema.
          </Typography>
        </Box>
      </Box>

      {flags === null && !error && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 4 }}>
          <CircularProgress size={24} />
          <Typography variant="body2" color="text.secondary">
            Carregando módulos...
          </Typography>
        </Box>
      )}

      {error && (
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={fetchFlags}>
              Tentar novamente
            </Button>
          }
        >
          Não foi possível carregar as configurações. Tente novamente mais
          tarde.
        </Alert>
      )}

      {flags !== null && !error && (
        <Box>
          {SETTINGS_MODULES.map((moduleConfig) => {
            const total = moduleConfig.flagKeys.length;
            const enabledCount = flags.filter(
              (flag) =>
                moduleConfig.flagKeys.includes(flag.key) && flag.enabled,
            ).length;

            return (
              <ModuleCard
                key={moduleConfig.moduleKey}
                config={moduleConfig}
                enabledCount={enabledCount}
                total={total}
                onClick={() => navigate(moduleConfig.route)}
              />
            );
          })}
        </Box>
      )}
    </Container>
  );
};
